import React from 'react';

interface FormTextareaProps {
  label: string;
  name: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  required?: boolean;
  rows?: number;
  error?: string;
}

const FormTextarea = ({
  label,
  name,
  placeholder,
  value,
  onChange,
  required = false,
  rows = 4,
  error,
}: FormTextareaProps) => {
  return (
    <div data-component-id="src/app/quote-request/components/FormTextarea.tsx:25:4" data-component-path="src/app/quote-request/components/FormTextarea.tsx" data-component-line="25" data-component-end-line="43" data-component-file="FormTextarea.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-2%22%7D" className="space-y-2">
      <label data-component-id="src/app/quote-request/components/FormTextarea.tsx:26:6" data-component-path="src/app/quote-request/components/FormTextarea.tsx" data-component-line="26" data-component-end-line="29" data-component-file="FormTextarea.tsx" data-component-name="label" data-component-content="%7B%22elementName%22%3A%22label%22%2C%22className%22%3A%22block%20text-sm%20font-body%20font-medium%20text-foreground%22%7D" htmlFor={name} className="block text-sm font-body font-medium text-foreground">
        {label}
        {required && <span data-component-id="src/app/quote-request/components/FormTextarea.tsx:28:21" data-component-path="src/app/quote-request/components/FormTextarea.tsx" data-component-line="28" data-component-end-line="28" data-component-file="FormTextarea.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-error%20ml-1%22%2C%22textContent%22%3A%22*%22%7D" className="text-error ml-1">*</span>}
      </label>
      <textarea data-component-id="src/app/quote-request/components/FormTextarea.tsx:30:6" data-component-path="src/app/quote-request/components/FormTextarea.tsx" data-component-line="30" data-component-end-line="41" data-component-file="FormTextarea.tsx" data-component-name="textarea" data-component-content="%7B%22elementName%22%3A%22textarea%22%2C%22id%22%3A%22%5Bvar%3Aname%5D%22%2C%22name%22%3A%22%5Bvar%3Aname%5D%22%2C%22value%22%3A%22%5Bvar%3Avalue%5D%22%7D"
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        rows={rows}
        className={`w-full px-4 py-3 rounded-lg border-2 font-body text-foreground placeholder:text-muted-foreground transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary/20 resize-none ${
          error ? 'border-error' : 'border-input focus:border-primary'
        }`}
      />
      {error && <p data-component-id="src/app/quote-request/components/FormTextarea.tsx:42:16" data-component-path="src/app/quote-request/components/FormTextarea.tsx" data-component-line="42" data-component-end-line="42" data-component-file="FormTextarea.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-error%20font-body%22%7D" className="text-sm text-error font-body">{error}</p>}
    </div>
  );
};

export default FormTextarea;